import { SpinnerLegacy } from "../../components";
import { InfiniteList } from "../../components/infiniteLoading/InfiniteList";
import { NavigationBarMenu } from "../../components/navigation/NavigationBar";
import { DistributionPalletShipmentListItem } from "./DistributionPalletShipmentListItem";
import { useSellarDistributionPalletShipmentList } from "./hooks/useSellarDistributionPalletShipmentList";

export const DistributionPalletShipmentsList = () => {
  return (
    <div>
      <NavigationBarMenu title={"SD Pallet Shipments"} />
      <List />
    </div>
  );
};

const List = () => {
  const palletShipmentListQuery = useSellarDistributionPalletShipmentList({
    limit: 10,
  });

  const palletShipmentList = palletShipmentListQuery.data?.pages.flat() ?? [];

  if (palletShipmentListQuery.isLoading) return <SpinnerLegacy />;

  return (
    <InfiniteList query={palletShipmentListQuery}>
      {palletShipmentList.map((palletShipment) => (
        <DistributionPalletShipmentListItem
          key={palletShipment.id}
          listItem={palletShipment}
        />
      ))}
    </InfiniteList>
  );
};
